/*
 * @Author: Tina Huang
 * @Date: 2024-02-23 14:01:56
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-17 16:22:01
 * @Description:
 */
type VIP_PALN = {
  title: string
  type: string
  price: number
  off: number
  rights?: string[]
  logos: string[]
  path?: string
  desc?: string[]
  large: boolean
  templates?: any[]
  activity?: string
  total_value?: number
}
export type VIP_MEMBER = {
  order: string
  phone: string
  nickname?: string
}

export const VipPlans: VIP_PALN[] = [
  // {
  //   title: '双模版永久会员',
  //   type: 'all',
  //   price: 399,
  //   off: 160, // 限时立减
  //   rights: ['全部FlowUs模版（含后续更新）', '全部Notion模版（含后续更新）', '限时分享组件', '模版定制服务享受8折优惠'],
  //   logos: ['./assets/logos/notion-logo.png', './assets/logos/FlowUs.png'],
  //   desc: ['模板更新频率请看其他的更新说明'],
  //   large: true,
  // },
  {
    title: 'Notion模版订阅库',
    type: 'notion',
    price: 299,
    off: 80, // 限时立减
    rights: ['全部Notion模版（含后续更新）', '限时分享组件', '模版定制服务享受9折优惠'],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['模板更新频率为平均一个月：1-3篇', '3次免费1v1咨询问答（30分钟/次）'],
    large: false,
    activity: '加赠15分钟的1v1咨询（至少提前1天预约）',
  },
  {
    title: 'FlowUs模版订阅库',
    type: 'flowus',
    price: 199,
    off: 100, // 限时立减
    rights: ['全部FlowUs模版（含后续更新）', '限时分享组件', '模版定制服务享受9折优惠'],
    logos: ['./assets/logos/FlowUs.png'],
    path: '/picks-detail/54',
    desc: ['模板更新频率为平均一个月：1-3篇', '更新后直接推送，可收到更新提醒'],
    large: false,
  },
]

export const VipFolderPlans: VIP_PALN[] = [
  {
    title: '小白上手',
    type: 'notion',
    price: 21.1,
    off: 11.2,
    templates: [27, 25, 10, 1, 29, 42, 3, 39],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['帮助你更好的了解Notion内基本操作的基础模版'],
    large: false,
    total_value: 21.1,
  },
  {
    title: '学生党必备',
    type: 'notion',
    price: 39.9,
    off: 5,
    templates: [83, 57, 28, 44, 50, 33],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['2026版考研，学期，时间，知识库等管理模版'],
    large: false,
  },
  {
    title: '工作党必备',
    type: 'notion',
    price: 29.9,
    off: 3,
    templates: [],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['项目，OKR，时间，GTD等管理模版'],
    large: false,
  },
  {
    title: 'J人必备',
    type: 'notion',
    price: 73.1,
    off: 13.1,
    templates: [86, 78, 69, 68, 67, 37, 55, 75, 53],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['2026年度计划进阶版，周计划，月计划等管理模版'],
    large: false,
    total_value: 73.1,
  },
  {
    title: '提升必备',
    type: 'notion',
    price: 49.9,
    off: 5,
    templates: [],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['积分管理，阅读观影，习惯打卡等管理模版'],
    large: false,
  },
  {
    title: '生活必备',
    type: 'notion',
    price: 69.9,
    off: 5,
    templates: [],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['囤货，旅行，衣橱，减肥，财务等管理模版'],
    large: false,
  },
  {
    title: '知识管理',
    type: 'notion',
    price: 89.9,
    off: 8,
    templates: [],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['知识库，复盘，文献阅读等管理模版'],
    large: false,
  },
  {
    title: '高能量必备',
    type: 'notion',
    price: 19.9,
    off: 3,
    templates: [],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['每月的高能量看板，每年的100件事等定期更新'],
    large: false,
  },
  {
    title: '1v1咨询',
    type: 'notion',
    price: 240,
    off: 81,
    templates: [0],
    logos: ['./assets/logos/notion-logo.png'],
    desc: ['3小时1v1咨询（语音/屏幕共享/远程控制），原价为80/h'],
    large: false,
  },
]

export const VipMembers: VIP_MEMBER[] = [
  {
    order: 'super-admin',
    phone: 'htt0728',
    nickname: 'Super Admin',
  },
  {
    order: 'test',
    phone: '19960728000',
    nickname: 'Super Admin',
  },
]
